import { render, staticRenderFns } from "./AmountSelectOneTime.vue?vue&type=template&id=634a4284"
import script from "./AmountSelectOneTime.vue?vue&type=script&lang=js"
export * from "./AmountSelectOneTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports